export default __webpack_public_path__ + "static/media/reviewingHomeMini.bde2e132.md";